export enum EPodkladAktivum {
    K = 'K',
    A = 'A',
    DN = 'DN',
    KM = 'KM',
    M = 'M',
    I = 'I',
    O = 'O'
}
